/* eslint-disable indent */
import io from "socket.io-client";
import store from "./store";
import {
  setChatMoveToNewTab,
  setErrorCode,
  setIsLoggedInAccountActive,
  setLogout,
} from "../src/component/redux/authUserDetail";
import { SOCKET_URL } from "./constants";
export let socket = null;
import {
  getAuthSession,
  getUpdateUnreadChatMessage,
  isElectron,
  SUPPORT_ADMIN_IDS,
} from "./component/Helpers/common";
import {
  addScheduledCall,
  addScheduledCallForHost,
  addWhiteBoardData,
  removeScheduledCall,
  setAllAttendeeList,
  setCallDetail,
  setScheduledGroup,
  setWhiteBoardData,
  setSketchBoardPosition,
  setMonitorScreeens,
  setMuteAllLoader,
} from "./component/redux/callSlice";
import {
  setLoderAttendeeDirect,
  setUnreadChatMessage,
  setChatMessage,
  setIsFetchingChatHistory,
  setDeleteChatData,
  setLoderAttendeeGroup,
  setSocketData,
  setIsSocketConnected,
  setGroupList,
  setPinnedChatMessage,
  setLoaderPinnedChatData,
  setChatFiles,
  setLoaderChatFilesData,
  setLoaderMorePinnedChat,
  setLoaderMoreChatFiles,
  setSearchedChatMessages,
  setLoaderSearchChatMessage,
  addPinnedMessages,
  addFilesMessages,
  setHasMoreChatFiles,
  setHasMorePinnedChatMessage,
  setThreadChatMessage,
  setThreadChatMessageObj,
  setUnreadThreadListObj,
} from "./component/redux/chatSlice";
import {
  startScheduledCall,
  raiseHandNotify,
  scheduledCallReminder,
  getParticipiantsJidSortedData,
  IndividualUserActionPerform,
  removeParticipantsScreenShared,
  sendGroupCallHangup,
} from "./component/Helpers/CallCommon";
import {
  addchatHistoryIndexDb,
  getMultipleImagesData,
  updateFilesMessagesStore,
  updateMessageIndexDb,
  updatePinnedMessagesStore,
  updateThreadChatMessageObj,
  userAccountExist,
} from "./component/Helpers/chatCommon";
import swal from "sweetalert";
import { getScreensInfo } from "./component/Helpers/Lib/screenShareInfo";
import * as Sentry from "@sentry/react";
import { addDataToDB } from "./component/util/indexedDB";
import { setParticipantsScreenShared } from "./component/Helpers/Lib/libSlice";

export const _socketConnect = (paramObj) => {
  const { dispatch } = store;
  return new Promise((resolve) => {
    socket = io(SOCKET_URL, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 99999,
    });
    socket.on("connect", async () => {
      console.log("CONNECT");
      dispatch(setIsSocketConnected(true));
      dispatch(setSocketData(socket));
      if (socket.connected) {
        const tokenRes = await _sendToken({ ...paramObj });
        return resolve(tokenRes);
      }
    });
    socket.on("reconnect", async () => {
      console.log("RECONNECT");
      if (socket.connected) {
        dispatch(setIsSocketConnected(true));
        dispatch(setSocketData(socket));
        const { login_token } = getAuthSession();
        userAccountExist(login_token);
      }
    });
    socket.on("disconnect", (reason) => {
      // dispatch(setIsSocketConnected(false));
      console.error("disconnect", reason);
      const state = store.getState();
      const { authSessionUser } = state.authUserDetail;
      if (authSessionUser?.onCall === true) {
        Sentry.captureEvent({
          message: "API socket disconnected",
          level: "info",
          extra: {
            additionalData: {
              name: authSessionUser?.name,
              company_id: authSessionUser?.company_id,
              roomId: authSessionUser?.roomId,
              user_id: authSessionUser?.user_id,
              username: authSessionUser?.username,
              onCall: authSessionUser?.onCall,
            },
          },
        });
      }
    });
    socket.on("connect_error", (error) => {
      // dispatch(setIsSocketConnected(false));
      console.log("connect_error", error);
    });

    // socket.on("sketchBoard-Pos", (data) => {
    //   dispatch(setSketchBoardPosition(data));
    // });
  });
};

export const _sendToken = (tokenObj) => {
  const storeToken = store.getState().authUserDetail.userLoginToken;
  let newTokenObj = {};
  if (tokenObj != undefined) {
    if (tokenObj.unique_token === null) {
      newTokenObj["unique_token"] = storeToken;
    } else {
      newTokenObj = { ...tokenObj };
    }
  } else {
    newTokenObj["unique_token"] = storeToken;
  }
  return new Promise((resolve) => {
    newTokenObj["isDesktopApp"] = isElectron;
    console.log("newTokenObj", newTokenObj);
    socket.emit(
      "con",
      {
        doc: newTokenObj,
      },
      (response) => {
        return resolve(response);
      },
    );
  });
};

export const _getVerifyTokenData = (cb) => {
  socket.on("con", (doc) => {
    cb(doc);
  });
};

export const _getUsers = () => {
  const { dispatch } = store;
  socket.on("users", (doc) => {
    // const user_unique_key = getMyUserId();
    // let User = doc.find((obj) => obj?.user_id === user_unique_key);
    // const UpdatedUser = { ...User };
    // UpdatedUser["isDesktopApp"] = isElectron;
    // _userUpdate(UpdatedUser);
    store.dispatch(setAllAttendeeList(doc));
    dispatch(setLoderAttendeeDirect(false));
  });
};

export const _getGroups = () => {
  const { dispatch } = store;
  socket.on("groups", (data) => {
    console.log("🚀 ~ _getGroups ~ data:", data);
    const Groups = data.filter(
      (filterItem) => filterItem.group_active === true,
    );
    dispatch(setGroupList(Groups));
    dispatch(setLoderAttendeeGroup(false));
  });
};

export const _userAdd = (userData) => {
  socket.emit("user-add", {
    doc: userData,
  });
};

// export const _updateSketchBoardPosition = (data) => {
//   socket.emit("sketchBoard-Pos", {
//     doc: data,
//   });
// };
export const _getUserAddedData = () => {
  socket.on("user-add", (data) => {
    const state = store.getState();
    const { allAttendeeList } = state.call;
    const newUsersList = [...allAttendeeList];
    newUsersList.push(data);
    store.dispatch(setAllAttendeeList(newUsersList));
  });
};

export const _getUserCurrentSessionEnd = () => {
  socket.on("new-session", (data) => {
    const state = store.getState();
    const { id } = state?.chat?.socketData ?? {};
    const { user_id } = state?.authUserDetail?.authSessionUser ?? {};
    if (id !== data?.socket_id && data?.user_id === user_id) {
      store.dispatch(setChatMoveToNewTab(true));
    }
  });
};

export const _userUpdate = (userData) => {
  socket.emit("user-upd", {
    doc: userData,
  });
};

export const _getUserUpdatedData = () => {
  socket.on("user-upd", (data) => {
    const state = store.getState();
    const { allAttendeeList } = state.call;
    const { authSessionUser, logout } = state.authUserDetail;
    const prevUsers = allAttendeeList;
    let newUsersList = [...allAttendeeList];

    if (authSessionUser?.user_id === data?.user_id) {
      //Get user index
      const userIndex = prevUsers.findIndex(
        (obj) => obj.user_id === data?.user_id,
      );
      newUsersList[userIndex] = data;
      if (!logout) {
        if (data.user_active === false) {
          store.dispatch(setIsLoggedInAccountActive(true));
          store.dispatch(setErrorCode(403));
        } else {
          store.dispatch(setIsLoggedInAccountActive(false));
          store.dispatch(setErrorCode(""));
        }
      }
    } else {
      if (data.user_active === true) {
        const userIndex = prevUsers.findIndex(
          //Get user index
          (obj) => obj.user_id === data?.user_id,
        );
        if (userIndex !== -1) {
          newUsersList[userIndex] = data; // update data
        }
      } else {
        newUsersList = prevUsers.filter(
          // remove group from list
          (filterItem) => filterItem.user_id !== data?.user_id,
        );
      }
    }
    store.dispatch(setAllAttendeeList(newUsersList));
  });
};

export const _userRemove = (userData) => {
  socket.emit("user-rem", {
    doc: userData,
  });
};

export const _getAfterUserRemovedData = () => {
  socket.on("user-rem", (data) => {
    const state = store.getState();
    const { allAttendeeList } = state.call;
    const prevUsersList = [...allAttendeeList];
    const newUsersList = prevUsersList.filter(
      // remove user from list
      (filterItem) => filterItem.user_id !== data?.user_id,
    );
    store.dispatch(setAllAttendeeList(newUsersList));
  });
};

export const _groupAdd = (groupData) => {
  socket.emit("group-add", {
    doc: groupData,
  });
};

export const _getGroupAddedData = () => {
  socket.on("group-add", (data) => {
    const state = store.getState();
    const { dispatch } = store;
    const { groupList } = state.chat;
    const newGroupsList = [...groupList];
    newGroupsList.unshift(data); // added new group into list at first position
    dispatch(setGroupList(newGroupsList));
  });
};

export const _groupUpdate = (groupData) => {
  socket.emit("group-upd", {
    doc: groupData,
  });
};

export const _groupUsersRemove = (groupData) => {
  socket.emit("group-rem-id", {
    doc: groupData,
  });
};

export const _getGroupUpdatedData = () => {
  socket.on("group-upd", (data) => {
    const state = store.getState();
    const { groupList } = state.chat;
    const { dispatch } = store;

    let newGroupList = [...groupList];
    if (data.group_active === true) {
      const groupIndex = groupList.findIndex(
        // get index of group
        (obj) => obj.groupId === data.groupId,
      );
      if (groupIndex === -1) {
        newGroupList.push(data);
      } else {
        newGroupList[groupIndex] = data; // update group data using index
      }
    } else {
      newGroupList = groupList.filter(
        // remove group from list
        (filterItem) => filterItem.groupId !== data.groupId,
      );
    }
    dispatch(setGroupList(newGroupList));

    const { authSessionUser } = state.authUserDetail;
    const { callDetail, allAttendeeList } = state.call;
    if (
      data?.groupCall &&
      !data?.attendeeId?.includes(authSessionUser?.user_id)
    ) {
      const props = {
        groupList,
        callDetails: callDetail,
        user_unique_key: authSessionUser?.user_id,
      };
      sendGroupCallHangup(props, allAttendeeList);
    }
  });
};

export const _groupRemove = (groupData) => {
  socket.emit("group-rem", {
    doc: groupData,
  });
};

export const _getAfterGroupRemovedData = () => {
  socket.on("group-rem", (data) => {
    const state = store.getState();
    const { dispatch } = store;
    const { groupList } = state.chat;

    const prevGroupList = [...groupList];
    const newGroupList = prevGroupList.filter(
      // remove group from list
      (filterItem) => filterItem.groupId !== data.groupId,
    );
    dispatch(setGroupList(newGroupList));

    const { authSessionUser } = state.authUserDetail;
    const { callDetail, allAttendeeList } = state.call;
    if (data?.groupCall) {
      const props = {
        groupList,
        callDetails: callDetail,
        user_unique_key: authSessionUser?.user_id,
      };
      sendGroupCallHangup(props, allAttendeeList);
    }
  });
};

export const _sendChatMessage = (chatData, event = "chat") => {
  socket.emit(
    event,
    {
      doc: chatData,
    },
    (response) => {
      console.log("_sendChatMessage response", response);
    },
  );
};

export const _getUpdatedChatMessage = (user_id) => {
  socket.on("chat", (data) => {
    const state = store.getState();
    const {
      chatRoom,
      isChatHistoryEnableOnce,
      isScrollingUp,
      unreadChatMessage,
    } = state.chat;
    const roomId = chatRoom;

    const newChat = [...store.getState().chat.chatMessage];
    const newChatThread = [...store.getState().chat.threadChatMessage];
    const findIndex = newChat.findIndex((findItem) => findItem.id === data.id);

    // const
    //////////////////////////////////////
    // For Thread Part

    if (data?.thread_id && data?.parent_id) {
      const parentMsgIdIndex = newChat.findIndex(
        (findItem) => findItem.id === data.parent_id,
      );

      newChat[parentMsgIdIndex] = {
        ...newChat[parentMsgIdIndex],
        thread: true,
      };

      store.dispatch(setThreadChatMessage([data, ...newChatThread]));

      const prevObj = store.getState().chat.threadChatMessageObj;

      const updatedObj = updateThreadChatMessageObj(
        prevObj,
        data?.documentID, // chatRoomId
        data?.parent_id, // parentMsgId
        data, // message
      );

      store.dispatch(setThreadChatMessageObj(updatedObj));

      // for unread thread message count update

      const activeThreadChat = store.getState().chat.activeThreadChat;

      // 1️⃣ If user is already viewing this thread
      if (
        activeThreadChat &&
        activeThreadChat[data?.documentID]?.id !== data?.parent_id
      ) {
        const prevUnreadThreadList =
          store.getState().chat.unreadThreadListObj || {};

        // 2️⃣ Get unread list for current document (chat room)
        const prevList = prevUnreadThreadList[data?.documentID] || [];

        // 3️⃣ Check if parent_id already exists
        const existingIndex = prevList.findIndex(
          (item) => item.parent_id === data?.parent_id,
        );

        let updatedList;

        if (existingIndex !== -1) {
          // 4️⃣ If exists → increment count
          updatedList = prevList.map((item, index) =>
            index === existingIndex
              ? { ...item, count: (Number(item.count) || 0) + 1 }
              : item,
          );
        } else {
          // 5️⃣ If not exists → add new unread thread
          updatedList = [
            ...prevList,
            {
              parent_id: data?.parent_id,
              documentID: data?.documentID,
              company_id: data?.company_id,
              count: 1,
            },
          ];
        }

        // 6️⃣ Update unreadThreadListObj for this document
        const updatedUnreadThreadList = {
          ...prevUnreadThreadList,
          [data?.documentID]: updatedList,
        };

        // 7️⃣ Dispatch update
        store.dispatch(setUnreadThreadListObj(updatedUnreadThreadList));
      }
    }

    ///////////////////////////////////////////////

    if (data.edited === false) {
      //---------------------user should be on top which either receive message or send message concept code end -------------------------//
      if (data.senderID === user_id) {
        getUpdateUnreadChatMessage(data.receiverID, "lastUserActivity");
      }

      if (roomId !== data.documentID) {
        if (data?.deleted === false) {
          if (data.type === "private") {
            if (data.receiverID === user_id) {
              getUpdateUnreadChatMessage(data.senderID, "countUpdate");
            }
          } else {
            if (data.senderID !== user_id) {
              const groupMuteData = store.getState().chat.unreadChatMessage;
              const groupMuteElement = groupMuteData.filter(
                (filterItem) =>
                  filterItem.id === data.receiverID ||
                  filterItem.user_id === data.receiverID,
              );
              if (groupMuteElement.length > 0) {
                const groupMuteValue = groupMuteElement[0]?.group_mute ?? false;
                const message = data.message;
                const isALLTagged = message?.match("all_c2p_tagged");
                if (
                  groupMuteValue === false ||
                  (isALLTagged !== null && isALLTagged.length > 0)
                ) {
                  getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
                } else {
                  const message = data.message;
                  const isUserTagged = message?.match(user_id);
                  if (isUserTagged !== null && isUserTagged.length > 0) {
                    getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
                  }
                }
              } else {
                getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
              }
            }
          }
        } else {
          if (data.id) {
            const updatedUnreadChatMessage = unreadChatMessage.filter(
              (item) => item.id !== data.id,
            );
            store.dispatch(setUnreadChatMessage(updatedUnreadChatMessage));
          }
        }
      }
    }

    if (roomId === data.documentID) {
      // validate received data should be corresponding to selected room
      if (findIndex === -1) {
        newChat.unshift(data);
        const tmpArray = [];
        tmpArray.push(data);
        getMultipleImagesData(tmpArray);
        if (isChatHistoryEnableOnce || isScrollingUp) {
          if (data?.deleted === false) {
            if (data.type === "private") {
              if (data.receiverID === user_id) {
                getUpdateUnreadChatMessage(data.senderID, "countUpdate");
              }
            } else {
              if (data.senderID !== user_id) {
                getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
              }
            }
          }
        }
      } else {
        if (!data?.deleted) {
          newChat[findIndex] = data;
        } else {
          store.dispatch(setDeleteChatData(data));
          newChat.splice(findIndex, 1);
        }
      }
    }

    store.dispatch(setChatMessage(newChat));
    updateMessageIndexDb(data);
    updatePinnedMessagesStore(data);
    updateFilesMessagesStore(data);
  });
};
export const _getUpdatedChatSupportMessage = (user_id) => {
  socket.on("phone-support", (data) => {
    const state = store.getState();
    const {
      chatRoom,
      isChatHistoryEnableOnce,
      isScrollingUp,
      unreadChatMessage,
    } = state.chat;

    const msgBySupportAdmin = SUPPORT_ADMIN_IDS.includes(data?.senderID);

    const roomId = chatRoom;

    const newChat = [...store.getState().chat.chatMessage];
    const newChatThread = [...store.getState().chat.threadChatMessage];
    const findIndex = newChat.findIndex((findItem) => findItem.id === data.id);

    // For Thread Part

    if (data?.thread_id && data?.parent_id) {
      const parentMsgIdIndex = newChat.findIndex(
        (findItem) => findItem.id === data.parent_id,
      );

      newChat[parentMsgIdIndex] = {
        ...newChat[parentMsgIdIndex],
        thread: true,
        support_status: data?.support_status
          ? data?.support_status
          : msgBySupportAdmin
          ? "answered"
          : "unanswered",
      };

      store.dispatch(setThreadChatMessage([data, ...newChatThread]));

      const prevObj = store.getState().chat.threadChatMessageObj;

      const updatedObj = updateThreadChatMessageObj(
        prevObj,
        data?.documentID, // chatRoomId
        data?.parent_id, // parentMsgId
        data, // message
      );

      store.dispatch(setThreadChatMessageObj(updatedObj));

      // for unread thread message count update

      const activeThreadChat = store.getState().chat.activeThreadChat;

      // 1️⃣ If user is already viewing this thread
      if (
        activeThreadChat &&
        activeThreadChat[data?.documentID]?.id !== data?.parent_id
      ) {
        const prevUnreadThreadList =
          store.getState().chat.unreadThreadListObj || {};

        // 2️⃣ Get unread list for current document (chat room)
        const prevList = prevUnreadThreadList[data?.documentID] || [];

        // 3️⃣ Check if parent_id already exists
        const existingIndex = prevList.findIndex(
          (item) => item.parent_id === data?.parent_id,
        );

        let updatedList;

        if (existingIndex !== -1) {
          // 4️⃣ If exists → increment count
          updatedList = prevList.map((item, index) =>
            index === existingIndex
              ? { ...item, count: (Number(item.count) || 0) + 1 }
              : item,
          );
        } else {
          // 5️⃣ If not exists → add new unread thread
          updatedList = [
            ...prevList,
            {
              parent_id: data?.parent_id,
              documentID: data?.documentID,
              company_id: data?.company_id,
              count: 1,
            },
          ];
        }

        // 6️⃣ Update unreadThreadListObj for this document
        const updatedUnreadThreadList = {
          ...prevUnreadThreadList,
          [data?.documentID]: updatedList,
        };

        // 7️⃣ Dispatch update
        store.dispatch(setUnreadThreadListObj(updatedUnreadThreadList));
      }
    }

    ///////////////////////////////////////////////

    if (data.edited === false) {
      //---------------------user should be on top which either receive message or send message concept code end -------------------------//
      if (data.senderID === user_id) {
        getUpdateUnreadChatMessage(data.receiverID, "lastUserActivity");
      }

      if (roomId !== data.documentID) {
        if (data?.deleted === false) {
          if (data.type === "private") {
            if (data.receiverID === user_id) {
              getUpdateUnreadChatMessage(data.senderID, "countUpdate");
            }
          } else {
            if (data.senderID !== user_id) {
              const groupMuteData = store.getState().chat.unreadChatMessage;
              const groupMuteElement = groupMuteData.filter(
                (filterItem) =>
                  filterItem.id === data.receiverID ||
                  filterItem.user_id === data.receiverID,
              );
              if (groupMuteElement.length > 0) {
                const groupMuteValue = groupMuteElement[0]?.group_mute ?? false;
                const message = data.message;
                const isALLTagged = message?.match("all_c2p_tagged");
                if (
                  groupMuteValue === false ||
                  (isALLTagged !== null && isALLTagged.length > 0)
                ) {
                  getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
                } else {
                  const message = data.message;
                  const isUserTagged = message?.match(user_id);
                  if (isUserTagged !== null && isUserTagged.length > 0) {
                    getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
                  }
                }
              } else {
                getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
              }
            }
          }
        } else {
          if (data.id) {
            const updatedUnreadChatMessage = unreadChatMessage.filter(
              (item) => item.id !== data.id,
            );
            store.dispatch(setUnreadChatMessage(updatedUnreadChatMessage));
          }
        }
      }
    }

    if (roomId === data.documentID) {
      // validate received data should be corresponding to selected room
      if (findIndex === -1) {
        newChat.unshift(data);
        const tmpArray = [];
        tmpArray.push(data);
        getMultipleImagesData(tmpArray);
        if (isChatHistoryEnableOnce || isScrollingUp) {
          if (data?.deleted === false) {
            if (data.type === "private") {
              if (data.receiverID === user_id) {
                getUpdateUnreadChatMessage(data.senderID, "countUpdate");
              }
            } else {
              if (data.senderID !== user_id) {
                getUpdateUnreadChatMessage(data.receiverID, "countUpdate");
              }
            }
          }
        }
      } else {
        if (!data?.deleted) {
          newChat[findIndex] = data;
        } else {
          store.dispatch(setDeleteChatData(data));
          newChat.splice(findIndex, 1);
        }
      }
    }

    store.dispatch(setChatMessage(newChat));
    updateMessageIndexDb(data);
    updatePinnedMessagesStore(data);
    updateFilesMessagesStore(data);
  });
};

export const _sendChatRoomDetail = (chatRoomData) => {
  socket.emit("chat-list", {
    doc: chatRoomData,
  });
};
export const _sendChatRoomThreadDetail = (chatRoomData) => {
  socket.emit("thread-list", {
    doc: chatRoomData,
  });
};

export const _getMessageList = (
  cb,
  user_unique_key,
  chatRoomDetail,
  off = false,
) => {
  if (!off) {
    socket.on("chat-list", (data) => {
      // if (data.length > 0) {
      //   if (chatRoomDetail === data[0].documentID) {
      //     // validate received data should be corresponding to selected room
      //     if (data[0].type === "private") {
      //       if (
      //         data[0].senderID === user_unique_key ||
      //         data[0].receiverID === user_unique_key
      //       ) {
      //         store.dispatch(setChatMessage(data));
      //       }
      //     } else {
      //       store.dispatch(setChatMessage(data));
      //     }
      //     getMultipleImagesData(data);
      //   }
      // } else {
      //   store.dispatch(setChatMessage(data));
      // }

      if (data.length > 0) {
        if (chatRoomDetail === data[0].documentID) {
          if (data.length > 0) {
            const updatedData = data.filter((item) => item.deleted != true);
            const payload = {
              id: chatRoomDetail,
              list: updatedData,
            };
            addDataToDB(payload);
            store.dispatch(setChatMessage(updatedData));
            getMultipleImagesData(updatedData);
          } else {
            store.dispatch(setChatMessage([]));
          }
        }
      } else {
        store.dispatch(setChatMessage([]));
      }
    });
  } else {
    socket.removeAllListeners("chat-list");
    cb();
  }
};
export const _getUnreadThreadList = (cb, off = false) => {
  if (!off) {
    socket.on("unread-thread-list", (data) => {
      if (data?.length === 0) return;
      const prevObj = store.getState().chat.unreadThreadListObj;

      const updatedObj = {
        ...prevObj,
        [data[0].documentID]: data,
      };

      // Dispatch the action to update Redux state
      store.dispatch(setUnreadThreadListObj(updatedObj));
    });
  } else {
    socket.removeAllListeners("unread-thread-list");
    cb();
  }
};

export const _sendClearUnreadThreadCount = (eventData) => {
  socket.emit("clear-unread-thread-count", {
    doc: eventData,
  });
};

export const _getThreadMessageList = (
  cb,
  user_unique_key,
  chatRoomDetail,
  parent_id,
  off = false,
) => {
  if (!off) {
    socket.on("thread-list", (data) => {
      if (!data?.length) {
        store.dispatch(setThreadChatMessage([]));
        return;
      }

      // validate room
      if (chatRoomDetail !== data[0].documentID) return;
      if (parent_id !== data[0].parent_id) return;
      const prevObj = store.getState().chat.threadChatMessageObj;

      // const updatedData = data.filter((item) => item.deleted !== true);

      const filteredData = data?.filter((item) => !item.deleted) || [];

      const updatedData = [
        ...filteredData.slice(0, -1), // Get all items except the last one
        { ...filteredData[filteredData.length - 1], isFetched: true }, // Update the last one
      ];

      // ---------- NORMAL ARRAY (if still needed) ----------
      store.dispatch(setThreadChatMessage(updatedData));

      const key = `${chatRoomDetail}_${parent_id}`;

      const updatedObj = {
        ...prevObj,
        [key]: updatedData,
      };

      store.dispatch(setThreadChatMessageObj(updatedObj));

      getMultipleImagesData(updatedData);
    });
  } else {
    socket.removeAllListeners("thread-list");
    cb();
  }
};

export const _sendEvent = (eventData) => {
  socket.emit("event", {
    doc: eventData,
  });
};

export const _getEventList = (
  user_unique_key,
  setPrivateTypingDaa,
  setGroupTypingDaa,
  setNotificationData,
) => {
  socket.on("event", (data) => {
    if (
      data.event_type === "typing-start" ||
      data.event_type === "typing-end"
    ) {
      if (data.type === "private") {
        if (data.receiverID === user_unique_key) {
          setPrivateTypingDaa((preTypingData) => {
            const newTyping = [...preTypingData];
            const TypingIndex = preTypingData.findIndex(
              (obj) => obj.receiverID === data.receiverID,
            );
            if (TypingIndex != -1) {
              newTyping[TypingIndex] = data;
            } else {
              newTyping.push(data);
            }
            return newTyping;
          });
        }
      } else {
        setGroupTypingDaa((preTypingData) => {
          const newTyping = [...preTypingData];
          const TypingIndex = preTypingData.findIndex(
            (obj) => obj.receiverID === data.receiverID,
          );
          if (TypingIndex != -1) {
            newTyping[TypingIndex] = data;
          } else {
            newTyping.push(data);
          }
          return newTyping;
        });
      }
    } else if (
      data.event_type === "call-notification" ||
      data.event_type === "msg-notification"
    ) {
      if (data.type === "private") {
        if (data.receiverID === user_unique_key) {
          setNotificationData(data);
        }
      } else {
        if (data.senderID !== user_unique_key) {
          setNotificationData(data);
        }
      }
    } else if (data.event_type === "mute-all") {
      if (user_unique_key !== data?.senderID) {
        store.dispatch(setMuteAllLoader(true));
        setTimeout(() => {
          store.dispatch(setMuteAllLoader(false));
        }, 3000);
        IndividualUserActionPerform("mute");
      }
    } else if (data.event_type === "sketchBoard-Pos") {
      store.dispatch(setSketchBoardPosition(data.data));
    }
  });
};

export const _updateCall = (updateCallDetail) => {
  let payload = { ...updateCallDetail };
  socket.emit("call", {
    doc: payload,
  });
};

export const _updatedCallDetail = () => {
  const { dispatch } = store;
  socket.on("call", (data) => {
    let newDetail = { ...store.getState().call.callDetail };
    let prevData = store.getState().call.callDetail;
    const state = store.getState();
    const { authSessionUser } = state.authUserDetail;
    if (Object.keys(prevData).length > 0) {
      if (prevData.type === "private") {
        if (
          prevData.calling_status === "ended" ||
          prevData.calling_status === "decline"
        ) {
          newDetail = data;
        } else {
          if (prevData.id === data.id) {
            newDetail = data;
          } else if (prevData.user_added === true) {
            // eslint-disable-next-line no-unsafe-optional-chaining
            const tmpUserData = prevData?.participantID?.find(
              (v) => v.id === authSessionUser?.user_id,
            );
            if (
              tmpUserData?.status === "decline" ||
              tmpUserData?.status === "ended"
            ) {
              newDetail = data;
            }
          }
        }
      } else {
        if (prevData.calling_status === "ended") {
          newDetail = data;
        } else {
          if (prevData.id === data.id) {
            newDetail = data;
          } else {
            // eslint-disable-next-line no-unsafe-optional-chaining
            const tmpPartcularUserData = prevData?.participantID?.find(
              (v) => v.id === authSessionUser?.user_id,
            );
            if (
              tmpPartcularUserData?.status === "decline" ||
              tmpPartcularUserData?.status === "ended"
            ) {
              newDetail = data;
            }
          }
        }
      }
    } else {
      newDetail = data;
    }

    const participantID = newDetail?.participantID
      ? [...newDetail.participantID]
      : [];

    // const sortedList = getParticipiantsJidSortedData(participantID);
    // newDetail["participantID"] = sortedList;
    // dispatch(setCallDetail(newDetail));

    const sortedList = getParticipiantsJidSortedData(participantID);
    const updatedDetail = {
      ...newDetail,
      participantID: sortedList,
    };
    dispatch(setCallDetail(updatedDetail));

    /// scheduled call list manage
    const { scheduledCallList } = state.call;
    if (data?.scheduleId) {
      const scheduleCallIndex = scheduledCallList.findIndex(
        (item) => item.scheduleId === data?.documentID,
      );
      // eslint-disable-next-line no-unsafe-optional-chaining
      const tmpPartcularUserData = data?.participantID?.find(
        (v) => v.id === authSessionUser?.user_id,
      );
      if (scheduleCallIndex === -1) {
        if (
          data?.calling_status === "initiated" &&
          (tmpPartcularUserData?.status === "decline" ||
            tmpPartcularUserData?.status === "ended")
        ) {
          dispatch(
            addScheduledCall({
              scheduleId: data?.scheduleId,
              scheduleName: data?.groupName,
            }),
          );
        }
      } else {
        if (data?.calling_status === "ended") {
          dispatch(
            removeScheduledCall({
              scheduleId: data?.documentID,
              scheduleName: data?.groupName,
            }),
          );
        } else {
          if (tmpPartcularUserData?.status === "accepted") {
            dispatch(
              removeScheduledCall({
                scheduleId: data?.documentID,
                scheduleName: data?.groupName,
              }),
            );
          }
        }
      }
    }
  });
};

// export const _sendRoom = (roomDetail) => {
//   socket.emit("call-doc", {
//     doc: roomDetail,
//   });
// };

export const _getRoomDetail = (off = false) => {
  if (!off) {
    let roomDetail = new Promise((resolve) => {
      socket.on("call-doc", (data) => {
        return resolve(data);
      });
    });
    return roomDetail;
  } else {
    socket.removeAllListeners("call-doc");
  }
};

export const _unreadMessageCountUpdate = (unreadMessageCountData) => {
  socket.emit("unread-upd", {
    doc: unreadMessageCountData,
  });
};

export const _sendUnreadMessageCountList = (data) => {
  socket.emit("unread-list", {
    doc: data,
  });
};

export const _getUnreadMessageCountList = () => {
  socket.on("unread-list", (data) => {
    store.dispatch(setUnreadChatMessage(data));
  });
};

export const _getKeepAlive = () => {
  socket.on("keep-alive", (data) => {
    console.log("_getKeepAlive", data);
  });
};

export const _sendLoadMoreChatData = (data) => {
  socket.emit("chat-history", {
    doc: data,
  });
};

export const _getLoadMoreChatData = () => {
  socket.on("chat-history", (data) => {
    const prevChatData = [...store.getState().chat.chatMessage];
    const updatedData = data.filter((item) => item.deleted != true);
    prevChatData.push(...updatedData);
    getMultipleImagesData(updatedData);
    store.dispatch(setChatMessage(prevChatData));
    store.dispatch(setIsFetchingChatHistory(false));
    addchatHistoryIndexDb(updatedData);
  });
};

export const _editChatMessage = (chatData) => {
  socket.emit("chat-edit", {
    doc: chatData,
  });
};

export const _deleteChatMessage = (chatData) => {
  socket.emit("chat-delete", {
    doc: chatData,
  });
};

export const _searchChatMessage = (chatData) => {
  socket.emit("chat-filter", {
    doc: chatData,
  });
};

export const _getSearchChatMessage = () => {
  socket.on("chat-filter", (data) => {
    const updatedData = data.filter((item) => item.deleted != true);
    store.dispatch(setSearchedChatMessages(updatedData));
    store.dispatch(setLoaderSearchChatMessage(false));
    // store.dispatch(setChatMessage(updatedData));
  });
};

export const _getLogout = () => {
  socket.on("logout", () => {
    store.dispatch(setLogout(true));
  });
};

export const _getInstantCall = () => {
  socket.on("instant-call", (data) => {
    const { user_unique_key } = getAuthSession();
    store.dispatch(setScheduledGroup(data));
    const state = store.getState();
    const { allAttendeeList } = state.call;
    if (user_unique_key === data.adminId) {
      const adminData =
        allAttendeeList?.find((item) => item.user_id === data.adminId) ?? {};
      if (!adminData?.onCall) {
        swal({
          text: `You have scheduled a call with the name "${data?.scheduleName}". Do you want to start the call?`,
          dangerMode: true,
          buttons: { cancel: "Cancel ", later: "Later", confirm: "Start" },
          closeOnClickOutside: false,
        }).then((swalType) => {
          if (swalType === true) {
            startScheduledCall(data);
          } else if (swalType === "later") {
            store.dispatch(addScheduledCallForHost(data));
          }
        });
      }
    }
  });
};

export const _jumpToSpecificChatData = (doc) => {
  return new Promise((resolve) => {
    socket.emit("jump-to-day", { doc }, (res) => {
      const updatedRes = res.filter((item) => item.deleted != true);
      return resolve(updatedRes);
    });
  });
};

export const clearUnreadCount = (doc) => {
  return new Promise((resolve) => {
    socket.emit("clear-unread-count", { doc }, (res) => {
      return resolve(res);
    });
  });
};

export const whiteBoardElemets = (doc) => {
  socket.emit("wb-event-list", { doc });
};

export const getWhiteBoardElemets = () => {
  socket.on("wb-event-list", (data) => {
    const { dispatch } = store;
    dispatch(setWhiteBoardData(data));
  });
};

export const addWhiteBoardElemets = (doc) => {
  const state = store.getState();
  const { callDetail } = state.call;
  const { company_id, documentID, type, participantID, senderID, receiverID } =
    callDetail;
  let attendeeId = [];
  if (type === "group") {
    attendeeId = participantID.map((a) => a.id);
  } else {
    attendeeId.push(senderID);
    attendeeId.push(receiverID);
  }

  const payload = {
    company_id,
    documentID,
    attendeeId,
    ...doc,
  };
  socket?.emit("wb-event-add", { doc: payload });
};

export const getAddedWhiteBoardElemets = () => {
  socket.on("wb-event-add", (data) => {
    // const user_id = getMyUserId();
    const { dispatch } = store;
    // if (user_id !== data.source) {
    dispatch(addWhiteBoardData(data));
    // }
  });
};
export const updateWhiteBoardElemets = (doc) => {
  socket.emit("wb-event-upd", { doc });
};

export const getUpdateWhiteBoardElemets = () => {
  socket.on("wb-event-upd", (data) => {
    const { dispatch } = store;
    dispatch(addWhiteBoardData(data));
  });
};

export const clearWhiteBoardData = () => {
  const state = store.getState();
  const { callDetail } = state.call;
  const { company_id, documentID, type, participantID, senderID, receiverID } =
    callDetail;
  let attendeeId = [];

  if (type === "group") {
    attendeeId = participantID.map((a) => a.id);
  } else {
    attendeeId.push(senderID);
    attendeeId.push(receiverID);
  }
  const payload = {
    company_id,
    documentID,
    attendeeId,
  };
  socket.emit("wb-event-clear", { doc: payload });
};

export const getClearWhiteBoardData = () => {
  socket.on("wb-event-clear", (data) => {
    const { dispatch } = store;
    dispatch(setWhiteBoardData(data));
  });
};

export const raiseHandNotification = () => {
  const state = store.getState();
  const { callDetail } = state.call;
  const { authSessionUser } = state.authUserDetail;
  const { user_id, name } = authSessionUser;
  const {
    company_id,
    documentID,
    type,
    participantID,
    senderID,
    receiverID,
    user_added,
  } = callDetail;
  let attendeeId = [];

  if (type === "group" || (type === "private" && user_added === true)) {
    attendeeId = participantID
      .filter((filterItem) => filterItem?.id !== user_id)
      .map((a) => a.id);
  } else {
    if (user_id !== senderID) {
      attendeeId.push(senderID);
    }
    if (user_id !== receiverID) {
      attendeeId.push(receiverID);
    }
  }
  const payload = {
    company_id,
    documentID,
    attendeeId,
    name,
  };
  socket.emit("raise-hand-notification", { doc: payload });
};

export const getRaiseHandNotificaton = () => {
  socket.on("raise-hand-notification", (data) => {
    raiseHandNotify(data);
  });
};

export const _getInstantCallReminder = () => {
  socket.on("instant-call-reminder", (data) => {
    swal({
      text: `You have scheduled a call with the name "${data?.scheduleName.trim()}" in ${
        data?.reminder_minutes ?? 5
      } minutes.`,
      dangerMode: true,
      buttons: {
        cancel: false,
        Ok: true,
      },
      closeOnClickOutside: false,
    });
    scheduledCallReminder(data);
  });
};

export const _updateRecentlyUsedEmoticons = (payload) => {
  socket.emit("emoji-upd", { doc: payload });
};

export const _saveLogs = (payload) => {
  socket.emit("logs", { doc: payload });
};

export const _sendScreenInfoNotify = (payload) => {
  socket.emit("screens-info-notify", { doc: payload });
};

export const _getScreenInfoNotify = () => {
  socket.on("screens-info-notify", (data) => {
    if (isElectron) {
      getScreensInfo({
        company_id: data?.company_id,
        sender_id: data?.sender_id,
      });
    }
  });
};

export const _sendScreenInfo = (payload) => {
  socket.emit("get-screens-info", { doc: payload });
};

export const _getScreenInfo = () => {
  socket.on("get-screens-info", (data) => {
    store.dispatch(setMonitorScreeens(data?.screens));
  });
};

export const _desktopSystemStats = (payload) => {
  socket.emit("desktop-system-stats", { doc: payload });
};

export const _updateCallParticipants = (payload) => {
  socket.emit("call-att-upd", { doc: payload });
};

export const _getCallParticipants = () => {
  socket.on("call-att-upd", (data) => {
    const state = store.getState();
    const { callDetail } = state.call;
    const { participantsScreenShared } = state.lib;

    if (callDetail?.id === data.id) {
      if (
        callDetail?.calling_status === "ended" &&
        callDetail?.type === "private"
      ) {
        // console.log("private call");
      } else {
        const { participantID } = callDetail;
        let participant = Array.from(participantID);
        let index = participantID.findIndex(
          (v) => v.id === data?.participantID?.id,
        );
        let updatedCallDetails = { ...callDetail };
        //  for temporery code
        const updatedParticipantID = { ...data?.participantID };
        // if (updatedParticipantID.hand_raise) {
        //   let currenttimeUTC = new Date().toISOString();
        //   let timeStampUTC = Date.parse(currenttimeUTC);
        //   updatedParticipantID.hand_raised_timestamp = timeStampUTC
        // }
        participant[index] = updatedParticipantID;
        updatedCallDetails["participantID"] = participant;
        store.dispatch(setCallDetail(updatedCallDetails));
        if (
          data?.participantID?.screenShare === true &&
          data?.participantID?.status === "accepted"
        ) {
          if (!participantsScreenShared.includes(data?.participantID?.jid)) {
            const tmpParticipantsScreenShared = [...participantsScreenShared];
            tmpParticipantsScreenShared.push(data?.participantID?.jid);
            store.dispatch(
              setParticipantsScreenShared(tmpParticipantsScreenShared),
            );
          } else {
            if (
              data?.participantID?.status === "ended" ||
              data?.participantID?.status === "declined"
            ) {
              removeParticipantsScreenShared(data?.participantID?.jid);
            }
          }
        } else {
          removeParticipantsScreenShared(data?.participantID?.jid);
        }
      }
    }
  });
};

export const _callDocUpdate = (payload) => {
  socket.emit("call-upd", { doc: payload });
};

export const _getCallDocUpdate = () => {
  socket.on("call-upd", (data) => {
    const state = store.getState();
    const { callDetail } = state.call;

    if (callDetail?.id === data.id) {
      const updatedCallData = { ...data };
      updatedCallData.participantID = callDetail?.participantID;
      store.dispatch(setCallDetail(updatedCallData));
    }
  });
};

export const _addCallParticipants = (payload) => {
  socket.emit("call-att-add", { doc: payload });
};

export const _getAddedCallParticipants = () => {
  socket.on("call-att-add", (data) => {
    const state = store.getState();
    const { callDetail } = state.call;

    if (callDetail?.id === data.id) {
      const { participantID } = callDetail;
      let participant = Array.from(participantID);
      let updatedCallDetails = { ...callDetail };
      data?.participantID?.forEach((element) => {
        const isUserAlreadyExist = participant.findIndex(
          (filterItem) => filterItem.id === element?.id,
        );

        if (isUserAlreadyExist === -1) {
          participant.push(element);
        } else {
          participant[isUserAlreadyExist] = element;
        }
      });
      updatedCallDetails["participantID"] = participant;
      store.dispatch(setCallDetail(updatedCallDetails));
    }
  });
};

export const _callActiveGroup = (payload) => {
  return new Promise((resolve) => {
    socket.emit("call-active-group", { doc: payload }, (res) => {
      return resolve(res?.data ?? {});
    });
  });
};

export const _sendRoom = (roomDetail) => {
  return new Promise((resolve) => {
    socket.emit("call-doc", { doc: roomDetail }, (res) => {
      return resolve(res?.data ?? {});
    });
  });
};

export const _sendPinnedChatMessage = (payload) => {
  return new Promise(() => {
    socket.emit("chat-pin", {
      doc: payload,
    });
  });
};

export const _sendChatRoomPinnedMessage = (payload) => {
  store.dispatch(setLoaderPinnedChatData(true));
  socket.emit("chat-pinned-list", {
    doc: payload,
  });
};

export const _getChatRoomPinnedMessage = () => {
  socket.on("chat-pinned-list", (data) => {
    store.dispatch(setPinnedChatMessage(data));
    store.dispatch(setLoaderPinnedChatData(false));
    store.dispatch(addPinnedMessages(data));
  });
};

export const _sendLoadMoreChatRoomPinnedMessage = (payload) => {
  socket.emit("chat-pinned-history", {
    doc: payload,
  });
};

export const _getLoadMoreChatRoomPinnedMessage = () => {
  socket.on("chat-pinned-history", (data) => {
    const prev = store.getState().chat.pinnedChatMessages;
    if (data.length === 0) {
      store.dispatch(setHasMorePinnedChatMessage(false));
    }
    const updated = [...prev, ...data];
    store.dispatch(setPinnedChatMessage(updated));
    store.dispatch(setLoaderMorePinnedChat(false));
    store.dispatch(addPinnedMessages(updated));
  });
};

export const _sendChatRoomFiles = (payload) => {
  store.dispatch(setLoaderChatFilesData(true));
  socket.emit("chat-files", {
    doc: payload,
  });
};

export const _getChatRoomFiles = () => {
  socket.on("chat-files", (data) => {
    store.dispatch(setChatFiles(data));
    store.dispatch(setLoaderChatFilesData(false));
    store.dispatch(addFilesMessages(data));
  });
};

export const _sendLoadMoreChatRoomFiles = (payload) => {
  socket.emit("chat-files-history", {
    doc: payload,
  });
};

export const _getLoadMoreChatRoomFiles = () => {
  socket.on("chat-files-history", (data) => {
    const prev = store.getState().chat.chatFiles;
    if (data.length === 0) {
      store.dispatch(setHasMoreChatFiles(false));
    }
    const updated = [...prev, ...data];
    store.dispatch(setChatFiles(updated));
    store.dispatch(setLoaderMoreChatFiles(false));
    store.dispatch(addFilesMessages(updated));
  });
};
